// DS: B0
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
import { Url } from '@wix/da-url';
import { isTouch } from '@wix/da-editor-tiptap/pkg/components/utils/browser';
const SubmitButton = ({ id, className })=>{
    const { t } = useTranslation();
    const { href, biData, onClick: submitOnClick } = useSubmitMenuItem(_object_spread_props(_object_spread({}, submitButtonMenuItem), {
        link: Url.studio({
            openSubmitForm: true
        })
    }));
    // This fixes ipads not being able to access the dropdown menu
    const clickHandler = useCallback((e)=>{
        if (submitOnClick) {
            submitOnClick();
            return;
        }
        if (isTouch()) {
            e.preventDefault();
            return;
        }
    }, [
        submitOnClick
    ]);
    return /*#__PURE__*/ React.createElement(BrandedButton, {
        id: id,
        size: "medium",
        variant: "brand-green",
        icon: Add16,
        className: className,
        href: href,
        onClick: clickHandler,
        biData: biData
    }, t('siteHeader.submit'));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;

//# sourceMappingURL=SubmitButton.js.map